module.exports = __webpack_public_path__ + "static/how-card-yellow-7137f98ddb311deda666ff4c250a2cba.svg";